module.exports = {
      id: "corona-updates-icon-usage",
      viewBox: "0 0 25.374 25.18",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#corona-updates-icon",
      toString: function () {
        return this.url;
      }
    }